/* Creekside 2026 homepage behavior for Stiletto.
   Real cart: /cart/add.js, then Stiletto's own quick cart refreshes and opens.
   Every block re-initialises on Theme Editor section load. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s || '').replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); };
  var titleCase = function (t) { return t === t.toUpperCase() ? t.toLowerCase().replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); }).replace(/\bD'oro\b/i, "D'Oro") : t; };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Toast (errors / confirmations when no drawer) ---------- */
  var toastEl, toastT;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); var w = document.createElement('div'); w.className = 'ck'; w.appendChild(toastEl); document.body.appendChild(w); }
    toastEl.textContent = msg; toastEl.classList.add('show');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('show'); }, 2600);
  }

  /* ---------- Cart ---------- */
  function openStilettoCart() {
    document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
    var icon = document.querySelector('[data-js-cart-icon]');
    var trigger = icon && (icon.closest('a, button') || icon);
    if (document.querySelector('.quick-cart') && trigger) { setTimeout(function () { trigger.click(); }, 350); return true; }
    return false;
  }
  function addItems(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to bag'); return j; }); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ck-add]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (b.getAttribute('aria-busy') === 'true') return;
    b.setAttribute('aria-busy', 'true');
    addItems([{ id: Number(b.getAttribute('data-ck-add')), quantity: 1 }])
      .then(function () { if (!openStilettoCart()) toast('Added ' + titleCase(b.getAttribute('data-ck-title') || 'item') + ' to your bag'); })
      .catch(function (err) { toast(err.message); })
      .then(function () { b.removeAttribute('aria-busy'); });
  }, true);

  function init(scope) {
    scope = scope || document;
    $$('[data-ck-tc]', scope).forEach(function (a) { a.textContent = titleCase(a.textContent.trim()); });

    /* Navigator tabs */
    $$('.navigator', scope).forEach(function (sec) {
      var tabs = $$('.nav-tab', sec), panels = $$('.nav-panel', sec);
      tabs.forEach(function (t) { t.onclick = function () {
        tabs.forEach(function (x) { x.setAttribute('aria-selected', String(x === t)); });
        panels.forEach(function (p) { var on = p.id === t.getAttribute('aria-controls'); p.classList.toggle('active', on); p.hidden = !on; });
      }; });
    });

    /* Crew picks */
    $$('[data-ck-hosts]', scope).forEach(function (hosts) {
      var sec = hosts.closest('section');
      hosts.onclick = function (e) {
        var b = e.target.closest('[data-host]'); if (!b) return;
        var id = b.getAttribute('data-host');
        $$('[data-host]', hosts).forEach(function (x) { x.setAttribute('aria-selected', String(x === b)); });
        $$('[data-host-panel]', sec).forEach(function (p) { p.hidden = p.getAttribute('data-host-panel') !== id; });
      };
    });

    /* Guide */
    $$('[data-ck-guide]', scope).forEach(function (sec) {
      var data = []; try { data = JSON.parse($('[data-guide-data]', sec).textContent); } catch (err) { data = []; }
      var ans = { s: 2, f: ['creamy'], l: 2 };
      var list = $('[data-rec-list]', sec), ranked = [];
      function score(p) { var sc = 3 - Math.abs(p.s - ans.s) * 2; sc += ans.f.filter(function (f) { return p.f.indexOf(f) > -1; }).length * 2.2; sc += 1.5 - Math.abs(p.l - ans.l); return sc; }
      function render() {
        ranked = data.map(function (p) { return { p: p, s: score(p) }; }).sort(function (a, b) { return b.s - a.s; }).slice(0, 3);
        var max = 3 + (ans.f.length || 1) * 2.2 + 1.5;
        list.innerHTML = ranked.map(function (r) {
          var p = r.p, pct = Math.max(62, Math.min(98, Math.round((r.s / max) * 100)));
          return '<div class="rec"><img src="' + esc(p.img) + '" alt="" loading="lazy" width="96" height="96"><div><span class="match">' + pct + '% match</span><b><a href="' + esc(p.u) + '">' + esc(titleCase(p.t)) + '</a></b><p>' + esc(p.note) + '</p></div><div class="side"><span class="mono-num">from ' + esc(p.price) + '</span><button type="button" class="btn btn-primary btn-sm" data-ck-add="' + p.vid + '" data-ck-title="' + esc(p.t) + '">Add</button></div></div>';
        }).join('');
      }
      $$('.opts', sec).forEach(function (g) {
        var key = g.getAttribute('data-q'), multi = g.getAttribute('data-multi') === 'true';
        g.onclick = function (e) {
          var b = e.target.closest('.opt'); if (!b) return;
          if (multi) {
            var on = b.getAttribute('aria-pressed') === 'true';
            if (on && $$('.opt[aria-pressed="true"]', g).length === 1) return;
            b.setAttribute('aria-pressed', String(!on));
            ans.f = $$('.opt[aria-pressed="true"]', g).map(function (x) { return x.getAttribute('data-v'); });
          } else {
            $$('.opt', g).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
            ans[key] = Number(b.getAttribute('data-v'));
          }
          render();
        };
      });
      var all = $('[data-guide-add-all]', sec);
      if (all) all.onclick = function () {
        if (!ranked.length) return;
        addItems(ranked.map(function (r) { return { id: r.p.vid, quantity: 1 }; }))
          .then(function () { if (!openStilettoCart()) toast('Added your top three to the bag'); })
          .catch(function (err) { toast(err.message); });
      };
      render();
    });

    /* Arrivals filter */
    $$('[data-ck-arrivals]', scope).forEach(function (sec) {
      var tabs = $('.tabs', sec); if (!tabs) return;
      tabs.onclick = function (e) {
        var b = e.target.closest('button'); if (!b) return;
        var f = b.getAttribute('data-f');
        $$('button', tabs).forEach(function (x) { x.setAttribute('aria-selected', String(x === b)); });
        $$('.ck-cell', sec).forEach(function (c) { c.hidden = !(f === 'all' || c.getAttribute('data-tag') === f); });
      };
    });

    /* Rails */
    $$('[data-ck-rail]', scope).forEach(function (rail) {
      var sec = rail.closest('section');
      $$('[data-rail]', sec).forEach(function (b) { b.onclick = function () { rail.scrollBy({ left: Number(b.getAttribute('data-rail')) * rail.clientWidth * 0.8, behavior: 'smooth' }); }; });
    });

    /* Lounge hours */
    $$('[data-ck-hours]', scope).forEach(function (card) {
      var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      var H = card.getAttribute('data-ck-hours').split(',').map(function (r) { var x = r.split('-'); return [Number(x[0]), Number(x[1])]; });
      if (H.length !== 7 || H.some(function (h) { return isNaN(h[0]) || isNaN(h[1]); })) return;
      var fmt = function (h) { var ap = h >= 12 && h < 24 ? 'PM' : 'AM'; return (h % 12 || 12) + ' ' + ap; };
      var parts;
      try { parts = new Intl.DateTimeFormat('en-US', { timeZone: card.getAttribute('data-ck-tz') || 'America/New_York', weekday: 'long', hour: 'numeric', minute: 'numeric', hour12: false }).formatToParts(new Date()); } catch (err) { return; }
      var get = function (t) { return parts.filter(function (p) { return p.type === t; })[0].value; };
      var wd = get('weekday'), di = DAYS.indexOf(wd), now = (Number(get('hour')) % 24) + Number(get('minute')) / 60;
      var today = H[di], open = now >= today[0] && now < today[1];
      var on = $('[data-open-now]', card);
      on.textContent = open ? 'Open now · until ' + fmt(today[1]) : 'Closed now · opens ' + (now < today[0] ? 'today at ' + fmt(today[0]) : 'tomorrow');
      on.classList.toggle('closed', !open);
      var hrs = $('[data-hours]', card);
      hrs.innerHTML = [1, 2, 3, 4, 5, 6, 0].map(function (i) { return '<div class="' + (i === di ? 'today' : '') + '"><span>' + DAYS[i] + '</span><span>' + fmt(H[i][0]) + ' – ' + fmt(H[i][1]) + '</span></div>'; }).join('');
    });

    /* Reveal */
    var els = $$('.ck .reveal', scope).filter(function (el) { return !el.classList.contains('in'); });
    if ('IntersectionObserver' in window && !(window.Shopify && window.Shopify.designMode)) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { io.observe(el); });
    } else { els.forEach(function (el) { el.classList.add('in'); }); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
